<template>
    <!-- Admin → Generador de links (/admin/generic-link). Mismo diseño que Admin →
         Usuarios y Cupones (bkCuenta + cuentaMenu + usuariosAdmin.css) y
         linksAdmin.css (prefijo lk-). La lógica es la de siempre
         (ShareLinkController, apiUrls.adminLinks):
           GET    admin/links?page&per_page   lista paginada (+ registros por código)
           POST   admin/links {codelink?}     sin código la API genera uno al azar
           DELETE admin/links/{idlink}
         El link que se comparte es el registro del front con ?ref=<código>: el
         router lo guarda y el alta lo manda como referral_code. -->
    <div class="lk-page">
        <div class="bk us lk">
            <aside class="bk-side us-side">
                <router-link :to="{ name: 'admin' }" class="us-back">
                    <span aria-hidden="true" v-html="IC.back"></span>{{ $t('admin_links.back') }}
                </router-link>
                <h1 class="bk-title">{{ $t('admin_links.title_a') }} <span class="bk-grad">{{ $t('admin_links.title_b') }}</span></h1>
                <p class="bk-subtitle">{{ $t('admin_links.sub') }}</p>

                <div class="us-stats" aria-live="polite">
                    <div class="us-stat"><span class="us-stat-n">{{ numero(total) }}</span><span class="us-stat-k">{{ $t('admin_links.stat.links') }}</span></div>
                    <div class="us-stat"><span class="us-stat-n">{{ numero(registrosPagina) }}</span><span class="us-stat-k">{{ $t('admin_links.stat.signups') }}</span></div>
                </div>

                <ol class="lk-steps">
                    <li><span>1</span>{{ $t('admin_links.how.s1') }}</li>
                    <li><span>2</span>{{ $t('admin_links.how.s2') }}</li>
                    <li><span>3</span>{{ $t('admin_links.how.s3') }}</li>
                </ol>
            </aside>

            <section class="us-main lk-main" :aria-busy="String(cargando)">
                <!-- Nuevo link -->
                <form class="lk-new" novalidate @submit.prevent="crear">
                    <h2 class="lk-h">{{ $t('admin_links.new.title') }}</h2>
                    <div :class="['us-field', 'lk-new-field', { 'is-invalid': err }]">
                        <label class="us-field-l" for="lk-code">{{ $t('admin_links.new.code') }} <em>{{ $t('admin_links.new.optional') }}</em></label>
                        <div class="lk-new-row">
                            <input id="lk-code" ref="codigo" v-model="codigo" type="text" maxlength="60" autocomplete="off" spellcheck="false" class="us-mono" :placeholder="$t('admin_links.new.ph')" :aria-invalid="err ? 'true' : null" :aria-describedby="err ? 'lk-err' : 'lk-hint'" :disabled="creando" @input="err = ''" />
                            <button type="submit" class="bk-btn bk-btn--primary" :disabled="creando">
                                <span v-if="creando" class="bk-spinner"></span><span v-else aria-hidden="true" v-html="IC.plus"></span>{{ $t(creando ? 'admin_links.new.creating' : 'admin_links.new.create') }}
                            </button>
                        </div>
                        <span v-if="err" id="lk-err" class="us-field-e" role="alert">{{ err }}</span>
                        <span v-else id="lk-hint" class="us-field-h">{{ $t('admin_links.new.hint') }}</span>
                    </div>

                    <!-- Recién creado -->
                    <div v-if="nuevo" class="lk-done" role="status">
                        <span class="lk-done-ic" aria-hidden="true" v-html="IC.check"></span>
                        <div class="lk-done-txt">
                            <b>{{ $t('admin_links.new.done', { c: nuevo.codelink }) }}</b>
                            <a class="lk-url" :href="url(nuevo.codelink)" target="_blank" rel="noopener">{{ url(nuevo.codelink) }}</a>
                        </div>
                        <button type="button" class="bk-btn bk-btn--primary lk-copy-big" @click="copiar(nuevo)">
                            <span aria-hidden="true" v-html="IC.copy"></span>{{ $t('admin_links.l.copy') }}
                        </button>
                    </div>
                </form>

                <div class="lk-list-head">
                    <h2 class="lk-h">{{ $t('admin_links.l.title') }}</h2>
                    <span v-if="total" class="lk-count">{{ $tc('admin_links.l.count', total, { n: numero(total) }) }}</span>
                </div>

                <div v-if="cargando && !links.length" class="lk-loading"><HyFLoader variant="inline" /></div>
                <div v-else-if="error" class="us-empty">
                    <h3>{{ $t('admin_links.l.error_t') }}</h3>
                    <p>{{ $t('admin_links.l.error_p') }}</p>
                    <button type="button" class="bk-btn bk-btn--ghost" @click="cargar">{{ $t('admin_links.l.retry') }}</button>
                </div>
                <div v-else-if="!links.length" class="us-empty">
                    <h3>{{ $t('admin_links.l.none_t') }}</h3>
                    <p>{{ $t('admin_links.l.none_p') }}</p>
                </div>

                <ul v-else :class="['lk-list', { 'is-cargando': cargando }]">
                    <li v-for="l in links" :key="l.idlink" :class="['lk-card', { 'is-new': nuevo && nuevo.idlink === l.idlink }]">
                        <div class="lk-card-main">
                            <div class="lk-card-top">
                                <button type="button" class="lk-code" :aria-label="$t('admin_links.l.copy_code', { c: l.codelink })" :title="$t('admin_links.l.copy_code', { c: l.codelink })" @click="copiar(l, true)">
                                    <span class="lk-code-t">{{ l.codelink }}</span><span aria-hidden="true" v-html="IC.copy"></span>
                                </button>
                                <span :class="['lk-badge', { 'is-on': l.registros > 0 }]">{{ $tc('admin_links.l.signups', l.registros || 0, { n: numero(l.registros || 0) }) }}</span>
                            </div>
                            <a class="lk-url" :href="url(l.codelink)" target="_blank" rel="noopener">{{ url(l.codelink) }}</a>
                            <p class="lk-meta">
                                <span>{{ $t('admin_links.l.by', { a: l.admin_correo || '—' }) }}</span>
                                <span>{{ fecha(l.created_at) }}</span>
                                <span v-if="l.ultimo_registro">{{ $t('admin_links.l.last', { d: fecha(l.ultimo_registro) }) }}</span>
                            </p>
                        </div>
                        <div class="lk-actions">
                            <button type="button" class="bk-btn bk-btn--ghost" @click="copiar(l)"><span aria-hidden="true" v-html="IC.copy"></span>{{ $t('admin_links.l.copy') }}</button>
                            <a class="bk-btn bk-btn--ghost lk-icon-btn" :href="url(l.codelink)" target="_blank" rel="noopener" :aria-label="$t('admin_links.l.open', { c: l.codelink })" :title="$t('admin_links.l.open', { c: l.codelink })"><span aria-hidden="true" v-html="IC.ext"></span></a>
                            <button type="button" class="bk-btn bk-btn--ghost lk-icon-btn lk-del" :disabled="borrando === l.idlink" :aria-label="$t('admin_links.l.delete', { c: l.codelink })" :title="$t('admin_links.l.delete', { c: l.codelink })" @click="borrar(l)"><span aria-hidden="true" v-html="IC.trash"></span></button>
                        </div>
                    </li>
                </ul>

                <BkPaginacion :actual="pagina" :ultima="ultima" :total="total" @ir="irA" />
            </section>
        </div>

        <!-- Confirmación -->
        <div v-if="modal" class="us-modal">
            <div class="us-modal-bg" @click="responderModal(false)"></div>
            <div ref="modalCard" class="us-modal-card" role="alertdialog" aria-modal="true" aria-labelledby="lk-m-title" aria-describedby="lk-m-text" @keydown="teclaModal">
                <h2 id="lk-m-title">{{ modal.titulo }}</h2>
                <p id="lk-m-text">{{ modal.texto }}</p>
                <div class="us-modal-btns">
                    <button type="button" class="bk-btn bk-btn--ghost" @click="responderModal(false)">{{ $t('admin_links.k.cancel') }}</button>
                    <button ref="modalOk" type="button" class="bk-btn us-btn--danger" @click="responderModal(true)">{{ modal.ok }}</button>
                </div>
            </div>
        </div>

        <transition name="us-toast">
            <div v-if="aviso" :class="['us-toast', `us-toast--${aviso.tipo}`]" role="status" aria-live="polite">
                <span class="us-toast-ico" aria-hidden="true">{{ aviso.tipo === 'ok' ? '✓' : '!' }}</span><span>{{ aviso.txt }}</span>
            </div>
        </transition>
    </div>
</template>

<script>
import axios from 'axios';
import apiUrls from '@/new-constants/apiUrls';
import BkPaginacion from '@/components/Cuenta/BkPaginacion.vue';
import HyFLoader from '@/components/Loader/HyFLoader.vue';
import ICON from '@/components/Cuenta/iconos';

const P = d => `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${d}</svg>`;
// Íconos: texto fijo de este archivo, nunca datos del usuario.
const IC = {
    back: P('<path d="M15 18l-6-6 6-6"/>'),
    check: P('<path d="M20 6 9 17l-5-5"/>'),
    ext: P('<path d="M14 4h6v6M20 4l-9 9M19 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h5"/>'),
    plus: ICON.plus, copy: ICON.copy, trash: ICON.trash,
};
const POR_PAGINA = 20;
const LOCALES = { es: 'es-CL', en: 'en-US', pt: 'pt-BR', fr: 'fr-FR', it: 'it-IT', de: 'de-DE' };

export default {
    name: 'GenericLinkAdmin',
    components: { BkPaginacion, HyFLoader },
    data() {
        return {
            IC,
            links: [], total: 0, pagina: 1, ultima: 1, cargando: true, error: false,
            codigo: '', err: '', creando: false, nuevo: null,
            borrando: null, modal: null, aviso: null,
        };
    },
    computed: {
        loc() { return LOCALES[this.$i18n.locale] || 'es-CL'; },
        registrosPagina() { return this.links.reduce((n, l) => n + (Number(l.registros) || 0), 0); },
    },
    created() {
        this._avisoT = null;
        this.cargar();
    },
    beforeDestroy() { clearTimeout(this._avisoT); },
    methods: {
        async cargar() {
            const req = (this._req = (this._req || 0) + 1);
            this.cargando = true;
            this.error = false;
            try {
                const { data } = await axios.get(apiUrls.adminLinks, { params: { page: this.pagina, per_page: POR_PAGINA } });
                if (req !== this._req) return;
                // Paginado (Lumen) o lista simple, como lo leía la versión anterior.
                this.links = Array.isArray(data) ? data : (data.data || []);
                this.total = Array.isArray(data) ? data.length : Number(data.total || this.links.length);
                this.ultima = Array.isArray(data) ? 1 : Math.max(1, Number(data.last_page || 1));
                if (this.pagina > this.ultima) { this.pagina = this.ultima; this.cargar(); }
            } catch (e) {
                if (req !== this._req) return;
                console.error('[Links] No se pudieron cargar', e);
                this.error = true;
            } finally {
                if (req === this._req) this.cargando = false;
            }
        },
        irA(p) {
            this.pagina = p;
            this.cargar();
            this.$nextTick(() => { const h = this.$el.querySelector('.lk-list-head'); if (h) h.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
        },
        // Igual que antes: siempre desde VUE_APP_SITE_URL (o el origen actual).
        url(code) {
            const site = (process.env.VUE_APP_SITE_URL || window.location.origin).replace(/\/$/, '');
            return `${site}/registro/step-1/?ref=${encodeURIComponent(code)}`;
        },
        numero(n) { return Number(n || 0).toLocaleString(this.loc); },
        fecha(s) {
            if (!s) return '—';
            const d = new Date(String(s).slice(0, 19).replace(' ', 'T'));
            return isNaN(d.getTime()) ? s : d.toLocaleDateString(this.loc, { day: 'numeric', month: 'short', year: 'numeric' });
        },

        async crear() {
            if (this.creando) return;
            const code = this.codigo.trim();
            if (code && !/^[A-Za-z0-9._-]+$/.test(code)) {
                this.err = this.$t('admin_links.new.err_chars');
                this.$nextTick(() => this.$refs.codigo && this.$refs.codigo.focus());
                return;
            }
            this.creando = true;
            this.err = '';
            try {
                const { data } = await axios.post(apiUrls.adminLinks, code ? { codelink: code } : {});
                this.nuevo = data;
                this.codigo = '';
                this.pagina = 1;
                await this.cargar();
                this.avisar(this.$t('admin_links.toast.created', { c: data.codelink }), 'ok');
            } catch (e) {
                const r = e && e.response;
                if (r && r.status === 422) {
                    this.err = r.data && r.data.field === 'codelink' ? this.$t('admin_links.new.err_taken') : this.$t('admin_links.new.err_chars');
                    this.$nextTick(() => this.$refs.codigo && this.$refs.codigo.focus());
                } else {
                    console.error('[Links] No se pudo crear', e);
                    this.avisar(this.$t('admin_links.toast.error'), 'error');
                }
            } finally {
                this.creando = false;
            }
        },
        async copiar(l, soloCodigo) {
            const txt = soloCodigo ? l.codelink : this.url(l.codelink);
            try {
                await navigator.clipboard.writeText(txt);
                this.avisar(this.$t(soloCodigo ? 'admin_links.toast.code_copied' : 'admin_links.toast.copied'), 'ok');
            } catch (e) {
                this.avisar(this.$t('admin_links.toast.copy_fail'), 'error');
            }
        },
        async borrar(l) {
            if (this.borrando) return;
            const ok = await this.confirmar({
                titulo: this.$t('admin_links.k.del_t'),
                texto: this.$tc('admin_links.k.del_p', l.registros || 0, { c: l.codelink, n: l.registros || 0 }),
                ok: this.$t('admin_links.k.del_ok'),
            });
            if (!ok) return;
            this.borrando = l.idlink;
            try {
                await axios.delete(`${apiUrls.adminLinks}/${l.idlink}`);
                if (this.nuevo && this.nuevo.idlink === l.idlink) this.nuevo = null;
                this.avisar(this.$t('admin_links.toast.deleted', { c: l.codelink }), 'ok');
                await this.cargar();
            } catch (e) {
                console.error('[Links] No se pudo eliminar', e);
                this.avisar(this.$t('admin_links.toast.del_fail'), 'error');
            } finally {
                this.borrando = null;
            }
        },

        // ── Confirmación y aviso ─────────────────────────────────────────
        confirmar({ titulo, texto, ok }) {
            return new Promise(resolve => {
                this._modalFoco = document.activeElement;
                this.modal = { titulo, texto, ok, resolve };
                this.$nextTick(() => { if (this.$refs.modalOk) this.$refs.modalOk.focus(); });
            });
        },
        responderModal(v) {
            if (!this.modal) return;
            const { resolve } = this.modal;
            this.modal = null;
            const el = this._modalFoco;
            this.$nextTick(() => { if (el && document.contains(el)) el.focus(); });
            resolve(v);
        },
        teclaModal(e) {
            if (e.key === 'Escape') { e.preventDefault(); this.responderModal(false); return; }
            if (e.key !== 'Tab') return;
            const els = Array.from(this.$refs.modalCard.querySelectorAll('button'));
            const first = els[0], last = els[els.length - 1];
            if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
            else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        },
        avisar(txt, tipo) {
            clearTimeout(this._avisoT);
            this.aviso = { txt, tipo: tipo || 'ok' };
            this._avisoT = setTimeout(() => { this.aviso = null; }, 3200);
        },
    },
};
</script>

<style src="../../BankInformation/bkCuenta.css"></style>
<style src="../../Cuenta/cuentaMenu.css"></style>
<style src="../Usuarios/usuariosAdmin.css"></style>
<style src="./linksAdmin.css"></style>
